/**
 * Background color for info cards in the exam screens.
 *
 * This is the background color for the timer component and the question
 * palette.
 */
export const examDrawerInfoCardBackground = "#1d304b";

/**
 * Yellow color used for the exam timer on both the left drawer and on the
 * mobile app bar.
 */
export const examTimerYellow = "#ffff00";

/**
 * Dark blue color used on top row of the mobile user exam app bar.
 */
export const examAppBarTopRow = "#012250";
/**
 * Light blue color used on bottom row of the mobile user exam app bar.
 */
export const examAppBarBottomRow = "#203864";

export const examQuestionStatusAnswered = "#2f8d2b";
export const examQuestionStatusNotAnswered = "#eb5757";
export const examQuestionStatusMarkedForReview = "#56ccf2";
export const examQuestionStatusNotVisited = "#bdbdbd";
export const examQuestionStatusSelected = "#f9cb4d";

export const whiteDark = "#f2f2f2";
export const textGrey = "#a6a6a6";

/**
 * Yellow background color for free exam cards.
 */
export const freeExamCardBackgroundColor = "#ecd100";
